<template>
    <div class="activity-log">
        <b-card no-body>
            <b-card-header class="p-3">
                <b-row align-v="center">
                    <b-col>
                        <h3 class="mb-0">
                            Activity Log
                        </h3>
                    </b-col>
                    <b-col cols="4">
                        <el-date-picker
                        v-model="date_picked"
                        type="date"
                        value-format="yyyy-MM-dd"
                        class="float-right py-0"
                        placeholder="Pick a day"
                        @change="findActivityLogs">
                        </el-date-picker>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-row class="p-3" v-if="current_lead_logs.length > 0">
                <b-col 
                    cols="12" 
                    class="mb-3"
                    v-for="(log, index) in paginatedData"
                    :key="index"
                >
                    <div v-if="log.event_type === 'created' && log.table === 'meetings'">
                        <p class="mb--1 font-weight-normal text-sm">
                            <span class="text-capitalize font-weight-600">{{ log.title}}</span>(Meeting) was created by <span class="font-weight-600">{{ log.causer.name }}</span>.
                        </p>
                        <small>{{ log.created_at | dateFormatString }}</small>
                    </div>
                    <div v-if="log.event_type === 'created' && log.table === 'leads'">
                        <p class="mb--1 font-weight-normal text-sm">
                            <span class="text-capitalize font-weight-600">{{ log.new_values.name}}</span> 
                            profile created by <span class="font-weight-600">{{ log.causer ? log.causer.name : 'N/A' }}</span>.
                        </p>
                        <small>{{ log.created_at | dateFormatString }}</small>
                    </div>
                    <div v-if="log.event_type === 'created' && log.table === 'lead_statuses'">
                        <p class="mb--1 font-weight-normal text-sm">
                            <span  v-if="log.new_values.main_status">
                                <span class="text-capitalize font-weight-600">Main Status</span> updated 
                                to <span class="font-weight-600">{{ log.new_values.main_status.name }}</span> 
                            </span>
                            <span  v-if="log.new_values.sub_status">
                                <span class="text-capitalize font-weight-600">Sub Status</span> updated 
                                to <span class="font-weight-600">{{ log.new_values.sub_status.name }}</span> 
                            </span>
                            by <span class="font-weight-600">{{ log.causer.name }}</span>.
                        </p>
                        <small>{{ log.created_at | dateFormatString }}</small>
                    </div>
                    <div v-if="log.event_type === 'updated'">
                        <div v-for="(newVal, key, index) in log.new_values" :key="key">
                            <div v-if="key !== 'customer_id'"
                                :class="Object.keys(log.new_values).length > 1 && index !== Object.keys(log.new_values).length - 1? 'mb-3' : 'mb-0'">
                                <p class="mb--1 font-weight-normal text-sm" v-if="log.old_values[key] && key !== 'approval_json'">
                                    <span class="text-capitalize font-weight-600">
                                      <span v-if="log.title">{{ log.title }} - </span>  {{ label[key] || key }}</span> changed 
                                    from <span class="font-weight-600">{{ log.old_values[key].name || log.old_values[key] }}</span> 
                                    to <span class="font-weight-600">
                                        <span v-if="newVal">{{ newVal.name || newVal }}</span>
                                        <span v-else>N/A</span>
                                    </span> 
                                    by <span class="font-weight-600">{{ log.causer.name }}</span>.
                                </p>
                                <p class="mb--1 font-weight-normal text-sm" v-else>
                                    <template v-if="label[key] || key === 'approval_json'">
                                        <span class="text-capitalize font-weight-600">{{ lead.name}}</span> profile <span class="badge badge-success">submitted for conversion</span> to customer
                                        by <span class="font-weight-600">{{ log.causer.name }}</span>.
                                    </template>
                                    <template v-else>
                                        <span class="text-capitalize font-weight-600">{{ label[key] || key }}</span> changed 
                                        to <span class="font-weight-600">
                                            <span v-if="newVal">{{ newVal.name || newVal }}</span>
                                            <span v-else>N/A</span>
                                        </span> 
                                        by <span class="font-weight-600">{{ log.causer.name }}</span>.
                                    </template>
                                </p>
                                <small>{{ log.created_at | dateFormatString }}</small>
                            </div>
                            <div v-else>
                                <p class="mb--1 font-weight-normal text-sm">
                                    <span class="text-capitalize font-weight-600">{{ lead.name}}</span> profile <span class="badge badge-success">converted</span> to customer
                                    by <span class="font-weight-600">{{ log.causer.name }}</span>.
                                </p>
                                <small>{{ log.created_at | dateFormatString }}</small>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12">
                    <el-pagination
                        class="float-right"
                        background
                        :current-page="currentPage"
                        :page-size=10
                        layout="prev, pager, next"
                        hide-on-single-page
                        :total=totalItems
                        @current-change="handlePageChange"
                        >
                    </el-pagination>
                </b-col>
            </b-row>
            <div v-else class="p-3">
                <span class="font-weight-bold text-sm">No record found.</span>
            </div>
        </b-card>
    </div>
</template>
<script>
import { DatePicker, Pagination } from 'element-ui'
import {
notifyFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { useLeadStore } from '@/stores/leadStore'

    export default {
        props: ['lead'],
        mixins: [notifyFunctionMixin],
        components: {
            [DatePicker.name]: DatePicker,
            [Pagination.name]: Pagination,
        },
        data() {
            return {
                date_picked: '',
                label: {
                    'platform_id': 'Platform',
                    'source_channel_id': 'Channel',
                    'main_status': 'Main Status',
                    'sub_status': 'Sub Status',
                    'contact_no': 'Contact No',
                    'meeting_id': 'Meeting',
                    'meeting_status': 'Meeting Status',
                    'start_at': 'Start Date',
                    'end_at': 'End Date',
                    'subject': 'Title'
                },
                totalItems: 0,
                paginatedData: [],
                currentPage: 1,
                pageSize: 10,
            }
        },

        computed:{
            ...mapState(useLeadStore, ['current_lead_logs']),
        },
        watch:{
            lead(newVal, oldVal){
                if(newVal){
                    this.getLeadActivityLog(this.$route.params.lead_id)
                }
            },
            current_lead_logs(newVal) {
                if(newVal) {
                    this.currentPage = 1
                    this.totalItems = newVal.length
                    const startIndex = (this.currentPage - 1) * this.pageSize;
                    const endIndex = startIndex + this.pageSize;
                    this.paginatedData = newVal.slice(startIndex, endIndex)
                }
            }
        },
        async created(){
            await this.getLeadActivityLog(this.$route.params.lead_id)
            this.totalItems = this.current_lead_logs.length
            this.updatePaginatedData();
        },
        methods:{
            ...mapActions(useLeadStore,['getLeadActivityLog']),
            findActivityLogs(){
                this.getLeadActivityLog(this.$route.params.lead_id, this.date_picked)
            },
            updatePaginatedData() {
                const startIndex = (this.currentPage - 1) * this.pageSize;
                const endIndex = startIndex + this.pageSize;
                this.paginatedData = this.current_lead_logs.slice(startIndex, endIndex);
            },
            handlePageChange(page) {
                this.currentPage = page; // Update the current page when it changes
                this.updatePaginatedData();
                // this.fetchData(); // Fetch the data for the new page
            },
        }
    }
</script>